import type { CharacterId } from './api';

export function claimPortraitIntro(
  greetedCharacters: Set<CharacterId>,
  characterId: CharacterId,
): boolean {
  if (greetedCharacters.has(characterId)) return false;
  greetedCharacters.add(characterId);
  return true;
}
